import { Routes } from '@angular/router';

export const routes: Routes = [{
    path: '',
    children: [
        {
            path: '',
            pathMatch: 'full',
             redirectTo: 'sales-order'
        },
        {
            path: 'job-order',
            loadChildren: () => import("./job-order/job-order.module").then((m) => m.JobOrderModule),
        },
        {
            path: 'stock-order',
            loadChildren: () => import("./normal-stock-order/normal-stock-order.module").then((m) => m.StockOrderModule),
        },
        {
            path: 'sales-inquiry',
            loadChildren: () => import("./sales-inquiry/sales-inquiry.module").then((m) => m.SalesInquiryModule),
        },
    
    ]
}];
